import { IconProps } from '../types';

const IcFilter = (props: IconProps) => (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
  <path d="M0 6.00005C0 5.33731 0.537258 4.80005 1.2 4.80005H22.8C23.4628 4.80005 24 5.33731 24 6.00005C24 6.66278 23.4628 7.20005 22.8 7.20005H1.2C0.537259 7.20005 0 6.66278 0 6.00005Z" fill={props?.fill ?? '#1D2129'}/>
  <path d="M3.59998 12C3.59998 11.3373 4.13724 10.8 4.79998 10.8H19.2C19.8627 10.8 20.4 11.3373 20.4 12C20.4 12.6628 19.8627 13.2 19.2 13.2H4.79998C4.13724 13.2 3.59998 12.6628 3.59998 12Z" fill={props?.fill ?? '#1D2129'}/>
  <path d="M9.60002 16.8C8.93729 16.8 8.40002 17.3373 8.40002 18C8.40002 18.6628 8.93729 19.2 9.60002 19.2H14.4C15.0628 19.2 15.6 18.6628 15.6 18C15.6 17.3373 15.0628 16.8 14.4 16.8H9.60002Z" fill={props?.fill ?? '#1D2129'}/>
</svg>
);

export default IcFilter;
